import { render, staticRenderFns } from "./ColumnsIcon.vue?vue&type=template&id=a00c1d4c&"
import script from "./ColumnsIcon.vue?vue&type=script&lang=js&"
export * from "./ColumnsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports